export default [
  'user',
  'token',
  'categorias',
  'colecoes',
  'tags',
  'autores',
  'midias',
  'editoras',
  'idiomas',
  'membros',
  'obras'
]